<template>
  <div class="login-main">
    <div class="login-bg"></div>
    <div class="login-form">
      <van-row>
        <van-col class="title" :span="24"> 注册登录 </van-col>
        <van-col :span="24" class="login-input">
          <van-cell-group>
            <van-field v-model="form.phoneNumber" placeholder="请输入手机号" />
            <img class="phoneicon" src="@/assets/images/login-phone.png" alt="" />
          </van-cell-group>
        </van-col>
        <van-col :span="24" class="login-input">
          <van-cell-group>
            <van-field v-model="form.smsCode" placeholder="验证码">
              <template #button>
                <van-button class="getcode" v-if="isgetcode" size="small" type="primary"
                  @click="getSmsCode">发送验证码</van-button>
                <van-count-down v-else :time="time" format=" ss 秒" @finish="numberend" />
              </template>
            </van-field>
            <img class="smsCode" src="@/assets/images/login-code.png" alt="" />
          </van-cell-group>
        </van-col>
      </van-row>
      <van-row class="submit">
        <van-col :span="24" class="login-rule">
          <van-checkbox style="width: max-content" v-model="checked" shape="square" checked-color="#2553e2"
            icon-size="14px"></van-checkbox>
          我已同意<span @click="openUserAgreement">《用户协议》</span>和<span @click="openPrivacyPolicy">《隐私政策》</span>
        </van-col>
        <van-col :span="24">
          <van-button round type="info" class="login-btn" @click="tologin">登录</van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { Notify } from "vant";
import { login, getSmsCode } from "@/api/login";
export default {
  data() {
    return {
      form: {
        phoneNumber: "",
        smsCode: "",
        // remember: true,
        // code: ''
      },
      checked: true,
      time: 60 * 1000,
      isgetcode: true,
    };
  },
  methods: {
    tologin() {
      this.form.phone = this.form.phoneNumber;
      login(this.form)
        .then((res) => {
          // console.log(res);
          Notify({ type: "success", message: res });
          this.$router.go(-1);
        })
        .catch((e) => {
          Notify({ type: "warning", message: e.message });
          this.isgetcode = true;
        });
    },
    getSmsCode() {
      if (this.form.phoneNumber != "") {
        this.isgetcode = false;
        getSmsCode({ phoneNumber: this.form.phoneNumber }).then((res) => {
          console.log(res);
        }).catch((e) => {
          this.isgetcode = true;
          Notify({ type: "warning", message: e.message });
        });
      } else {
        Notify({ type: "warning", message: "请输入手机号" });
      }
    },
    numberend() {
      this.isgetcode = true;
    },
    openUserAgreement() {
      this.$router.push({
        path: "/protocol",
      });
    },
    openPrivacyPolicy(){
      this.$router.push({
        path: "/policy",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.login-bg {
  height: 406px;
  background: url(../../assets/images/login-bg.png) no-repeat center center;
  background-size: cover;
}

.login-form {
  margin: -210px 22px 0;
  background: #fff;
  border-radius: 20px;
  padding: 0 22px;
  height: 50vh;

  .title {
    margin-top: 30px;
    box-sizing: border-box;
    font-size: 20px;
    color: #303030;
  }

  .van-hairline--top-bottom::after {
    border: none;
  }

  .login-input {
    margin-top: 30px;

    .van-cell {
      background: #f6f6f6;
      border-radius: 20px;
    }

    img {
      position: absolute;
      left: 5vw;
      top: 50%;
      transform: translateY(-50%);
    }

    .van-field {
      padding-left: 50px;
    }

    .getcode {
      background: none;
      border: none;
      color: #2553e2;
      height: 20px;
      font-size: 14px;
      display: flex;
      align-items: center;
    }

    .van-count-down {
      color: #2553e2;
    }
  }

  .submit {
    position: fixed;
    bottom: 32px;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
    background: #fff;

    .login-rule {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #c9c8c8;
      margin-bottom: 10px;

      span {
        color: #2553e2;
        cursor: pointer;
      }

      :deep .van-icon {
        border-radius: 3px;
        margin-right: 6px;
      }
    }

    .login-btn {
      width: 80vw;
      background: #2553e2;
    }
  }
}

.login-main {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
}

.phoneicon {
  width: 14px;
  height: 18px;
}

.smsCode {
  width: 16px;
  height: 19px;
}
</style>